// Portfolio of clients — organized by sector.
// Service strings are i18n keys; client names stay as-is (proper nouns).

export const SECTORS = [
  { key: "all", pt: "Todos", en: "All", es: "Todos" },
  { key: "government", pt: "Governo & Público", en: "Government", es: "Gobierno" },
  { key: "oil_gas", pt: "Petróleo & Gás", en: "Oil & Gas", es: "Petróleo y Gas" },
  { key: "diplomatic", pt: "Diplomático", en: "Diplomatic", es: "Diplomático" },
  { key: "private", pt: "Privado & Industrial", en: "Private & Industrial", es: "Privado e Industrial" },
];

// services translation map — each entry has pt/en/es for presentation
const S = {
  vsat_data_wireless: {
    pt: ["VSAT", "Rede de Dados", "Wireless"],
    en: ["VSAT", "Data Network", "Wireless"],
    es: ["VSAT", "Red de Datos", "Wireless"],
  },
  telecom_general: {
    pt: ["Telecomunicações Gerais"],
    en: ["General Telecoms"],
    es: ["Telecomunicaciones Generales"],
  },
  tv_security: {
    pt: ["TV", "Sistemas de Segurança"],
    en: ["TV", "Security Systems"],
    es: ["TV", "Sistemas de Seguridad"],
  },
  tv_security_cabling: {
    pt: ["TV", "Segurança", "Cablagem Estruturada Certificada"],
    en: ["TV", "Security", "Certified Structured Cabling"],
    es: ["TV", "Seguridad", "Cableado Estructurado Certificado"],
  },
  telecom_it: {
    pt: ["Telecomunicações", "Informática"],
    en: ["Telecoms", "IT"],
    es: ["Telecomunicaciones", "Informática"],
  },
  network_pbx: {
    pt: ["Rede", "Central Telefónica"],
    en: ["Network", "PBX"],
    es: ["Red", "Centralita Telefónica"],
  },
  telecom_systems: {
    pt: ["Sistemas de Telecomunicações"],
    en: ["Telecom Systems"],
    es: ["Sistemas de Telecomunicaciones"],
  },
  telecom_diverse: {
    pt: ["Telecomunicações Diversas"],
    en: ["Diverse Telecoms"],
    es: ["Telecomunicaciones Diversas"],
  },
};

export const CLIENTS = [
  {
    id: "gov-uige",
    name: "Governo da Província de Uíge",
    sector: "government",
    services: S.vsat_data_wireless,
  },
  {
    id: "gov-cabinda",
    name: "Governo da Província de Cabinda",
    sector: "government",
    services: S.telecom_general,
  },
  {
    id: "min-industria",
    name: "Ministério da Indústria",
    sector: "government",
    services: S.telecom_systems,
  },
  {
    id: "refinaria",
    name: "Refinaria de Luanda",
    sector: "oil_gas",
    services: S.telecom_general,
  },
  {
    id: "total",
    name: "Total",
    sector: "oil_gas",
    services: S.tv_security,
  },
  {
    id: "chevron",
    name: "Chevron Angola",
    sector: "oil_gas",
    services: S.tv_security_cabling,
  },
  {
    id: "esso",
    name: "Esso Exploration Angola",
    sector: "oil_gas",
    services: S.tv_security,
  },
  {
    id: "kwanda",
    name: "Base do Kwanda · Soyo",
    sector: "oil_gas",
    services: S.telecom_systems,
  },
  {
    id: "us-embassy",
    name: "US Embassy in Luanda",
    sector: "diplomatic",
    services: S.network_pbx,
  },
  {
    id: "lyon",
    name: "Lyon · Construções e Manutenções Metalomecânicas, S.A.",
    sector: "private",
    services: S.telecom_it,
  },
  {
    id: "novagest",
    name: "Novagest · Serviços e Gestão, S.A.",
    sector: "private",
    services: S.telecom_it,
  },
  {
    id: "luso-uno",
    name: "Luso Uno",
    sector: "private",
    services: S.telecom_it,
  },
  {
    id: "sgs",
    name: "SGS Angola, Lda",
    sector: "private",
    services: S.network_pbx,
  },
  {
    id: "mstelcom",
    name: "MSTelcom · Mercury Serviços de Telecomunicações, S.A.",
    sector: "private",
    services: S.telecom_systems,
  },
  {
    id: "acs",
    name: "ACS · Angola Comunicações e Sistemas",
    sector: "private",
    services: S.telecom_systems,
  },
  {
    id: "north-service",
    name: "North Service",
    sector: "private",
    services: S.telecom_systems,
  },
  {
    id: "private-misc",
    name: "Empresas Privadas",
    sector: "private",
    services: S.telecom_diverse,
  },
];

export const portfolioStrings = {
  pt: {
    nav: "Portefólio",
    overline: "Portefólio · Clientes",
    title: "Confiança construída em projectos reais.",
    subtitle:
      "Mais de duas décadas ao serviço de instituições públicas, empresas do sector petrolífero, representações diplomáticas e operadores privados em Angola.",
    stat_clients: "Clientes Institucionais",
    stat_sectors: "Sectores",
    stat_years: "Anos de Experiência",
    services_label: "Serviços prestados",
    sector_label: "Sector",
    cta_title: "O seu projecto é o próximo.",
    cta_desc:
      "Quer seja uma rede estruturada, uma central telefónica ou um sistema VSAT — temos a equipa, as marcas e a experiência para entregar.",
    cta_btn: "Solicitar Orçamento",
    filter_label: "Filtrar por sector",
    no_results: "Sem resultados neste filtro.",
  },
  en: {
    nav: "Portfolio",
    overline: "Portfolio · Clients",
    title: "Trust built on real projects.",
    subtitle:
      "Two decades serving public institutions, oil & gas companies, diplomatic missions and private operators in Angola.",
    stat_clients: "Institutional Clients",
    stat_sectors: "Sectors",
    stat_years: "Years of Experience",
    services_label: "Delivered services",
    sector_label: "Sector",
    cta_title: "Your project is next.",
    cta_desc:
      "Whether it's a structured network, a PBX or a VSAT — we have the team, brands and experience to deliver.",
    cta_btn: "Request a Quote",
    filter_label: "Filter by sector",
    no_results: "No clients in this filter.",
  },
  es: {
    nav: "Portafolio",
    overline: "Portafolio · Clientes",
    title: "Confianza construida en proyectos reales.",
    subtitle:
      "Dos décadas al servicio de instituciones públicas, empresas petroleras, misiones diplomáticas y operadores privados en Angola.",
    stat_clients: "Clientes institucionales",
    stat_sectors: "Sectores",
    stat_years: "Años de experiencia",
    services_label: "Servicios prestados",
    sector_label: "Sector",
    cta_title: "Tu proyecto es el siguiente.",
    cta_desc:
      "Ya sea una red estructurada, una centralita o un VSAT — tenemos el equipo, las marcas y la experiencia para entregar.",
    cta_btn: "Solicitar presupuesto",
    filter_label: "Filtrar por sector",
    no_results: "Sin resultados en este filtro.",
  },
};
